module.exports = __webpack_public_path__ + "static/media/print-solid-white.b8bfc27a.png";